exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-progress[data-v-62bbbb06]{margin-top:0.18rem;margin-bottom:0.18rem}.common-progress[data-v-62bbbb06] .el-progress-bar__inner{background:linear-gradient(267deg, #45d1ff 0%, #3172fd 100%)}.common-progress[data-v-62bbbb06] .el-progress-bar__outer{height:0.24rem !important;background:rgba(49,114,253,0.2)}.text-num .text-bold[data-v-62bbbb06]{font-size:0.18rem;line-height:0.21rem;font-family:Roboto-Medium, Roboto;font-weight:bold;color:#4C4C4C;margin-top:0.06rem}.text-num-desc[data-v-62bbbb06]{font-size:0.16rem;font-weight:normal;color:#aaaaaa;margin-bottom:0.08rem}\n", ""]);

// exports
